import { PriceControlValidateDTO } from '../dto';
import { EventHandlingResult } from './PriceControlItemEvents';

export class PriceControlValidate {
  memberEventId: number;
  mgItemNumber: number;
  finfoNumber: number;
  nobbNumber: number;
  primaryText: string;
  secondaryText: string;
  previousSalesPriceIncVat?: number;
  previousSalesPriceExVat?: number;
  previousCoverageDegree?: number;
  previousSalesFactor?: number;
  result: EventHandlingResult;
  isValid: boolean;

  constructor({
    memberEventId,
    mgItemNumber,
    finfoNumber,
    nobbNumber,
    primaryText,
    secondaryText,
    previousSalesPriceIncVat,
    previousSalesPriceExVat,
    previousCoverageDegree,
    previousSalesFactor,
    result,
    isValid,
  }: PriceControlValidate) {
    this.memberEventId = memberEventId;
    this.mgItemNumber = mgItemNumber;
    this.finfoNumber = finfoNumber;
    this.nobbNumber = nobbNumber;
    this.primaryText = primaryText;
    this.secondaryText = secondaryText;
    this.previousSalesPriceIncVat = previousSalesPriceIncVat;
    this.previousSalesPriceExVat = previousSalesPriceExVat;
    this.previousCoverageDegree = previousCoverageDegree;
    this.previousSalesFactor = previousSalesFactor;
    this.result = result;
    this.isValid = isValid;
  }

  static fromDto = (dto: PriceControlValidateDTO): PriceControlValidate =>
    new PriceControlValidate({
      memberEventId: dto.memberEventId,
      mgItemNumber: dto.mgItemNumber,
      finfoNumber: dto.finfoNumber,
      nobbNumber: dto.nobbNumber,
      primaryText: dto.primaryText,
      secondaryText: dto.secondaryText,
      previousSalesPriceIncVat: dto.previousSalesPriceIncVat,
      previousSalesPriceExVat: dto.previousSalesPriceExVat,
      previousCoverageDegree: dto.previousCoverageDegree,
      previousSalesFactor: dto.previousSalesFactor,
      result: EventHandlingResult.fromDto(dto.result),
      isValid: dto.isValid,
    });
}
